import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fb815572")
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({
    footer:true,
  })
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "brand" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_img logo" }),
  /*#__PURE__*/_createElementVNode("h4", { class: "name" }, "gochase.me")
], -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Games")
], -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Browse")
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Join")
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("History")
const _hoisted_12 = { class: "col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Utilities")
], -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Account")
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Partners")
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_20 = { class: "col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Service", -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Terms of service")
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Privacy policy")
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Cookie policy")
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("PWA")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/app" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, { to: "/app/join" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, { to: "/app/history" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_router_link, { to: "/account" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_router_link, { to: "/settings/partners" }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, { to: "/settings" }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_router_link, { to: "/policy/terms" }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_router_link, { to: "/policy/privacy" }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_router_link, { to: "/policy/cookie" }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_router_link, { to: "/policy/pwa" }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}